// extracted by mini-css-extract-plugin
export default {"headingText":"successPopup_headingText__i4XBp","slideTransition":"successPopup_slideTransition__vpnEr"};